import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleUp,
  faAngleDown,
  faPowerOff,
  faCreditCard,
  faPercent,
  faCog,
  faTimes,
  faPlus,
  faBox,
  faPlusSquare,
  faCalendar,
  faWindowClose,
  faExchangeAlt,
  faChevronDown,
  faTruck,
  faChevronLeft,
  faChevronRight,
  faCheck,
  faSearchPlus,
  faChevronUp,
  faLongArrowAltLeft,
  faCircle,
  faPhoneSquareAlt,
  faTrashAlt,
  faGift
} from '@fortawesome/free-solid-svg-icons'

import {
  faFileAlt,
  faMap,
  faEnvelope,
  faEdit,
  faUser
} from '@fortawesome/free-regular-svg-icons'

library.add(faAngleUp)
library.add(faAngleDown)
library.add(faPowerOff)
library.add(faCreditCard)
library.add(faPercent)
library.add(faBox)
library.add(faCog)
library.add(faTimes)
library.add(faPlus)
library.add(faEdit)
library.add(faPlusSquare)
library.add(faCalendar)
library.add(faWindowClose)
library.add(faFileAlt)
library.add(faUser)
library.add(faEnvelope)
library.add(faExchangeAlt)
library.add(faMap)
library.add(faChevronDown)
library.add(faTruck)
library.add(faChevronLeft)
library.add(faChevronRight)
library.add(faCheck)
library.add(faSearchPlus)
library.add(faChevronUp)
library.add(faLongArrowAltLeft)
library.add(faCircle)
library.add(faPhoneSquareAlt)
library.add(faGift)
library.add(faTrashAlt)

export default class Icon extends React.PureComponent {
  render () {
    const { iconName, regular } = this.props
    const icon = regular ? ['far', iconName] : iconName

    return (
      <i>
        <FontAwesomeIcon
          icon={icon}
        />
      </i>
    )
  }
}
